import { Card, Input } from 'antd';
import styled from 'styled-components';
import CustomInputField from '../../atoms/CustomInputField';
import CustomSelectBox from '../../atoms/CustomSelectBox';

export const Container = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px;
`;

export const CustomInputLeft = styled(CustomInputField)`
  width: 40px;
  height: 56px;
  textalign: center;
  display: flex;
  alignitems: center;
  justifycontent: center;
`;
export const SelectBoxLeft = styled(CustomSelectBox)`
  flex: 1;
  height: 56px;
`;
export const LeftSuffixInput = styled(CustomSelectBox)`
  width: 46px;
  height: 56px;
  textalign: center;
  display: flex;
  alignitems: center;
  justifycontent: center;
  backgroundcolor: #1677ff;
  color: white;
`;
